import React from "react";
import PropTypes from "prop-types";

// Segmented control for the source's scope axis. GCP projects and AI-provider workspaces are
// disjoint cost sets (a row is keyed by project_id OR source_key='ai:<workspace>'), so a source
// scopes exactly one. Making the axis an explicit choice prevents the financial footgun of an
// AI workspace ANDed onto a project scope — a combination that can never match any cost.
const OPTIONS = [
  { value: "project", label: "Projects", hint: "GCP cloud spend, by project" },
  { value: "ai_workspace", label: "AI workspaces", hint: "OpenAI / AI-provider spend" },
];

const ScopeAxisSwitch = ({ value, onChange }) => (
  <div>
    <p className="text-xs font-medium uppercase tracking-wide text-text-2 mb-2">Scope by</p>
    <div role="radiogroup" aria-label="Scope by" className="inline-flex rounded-seg border border-border bg-surface-2 p-0.5">
      {OPTIONS.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            title={o.hint}
            onClick={() => onChange(o.value)}
            className={
              "px-3 py-1.5 text-sm rounded-tab transition-colors " +
              (active
                ? "bg-card text-text font-medium"
                : "text-text-2 hover:text-text")
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  </div>
);

ScopeAxisSwitch.propTypes = {
  value: PropTypes.oneOf(["project", "ai_workspace"]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ScopeAxisSwitch;
